"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import { Avatar, Separator, Text } from "@/elements"
import { MetadataSectionContainer } from "./MetadataSectionContainer"
import { ClientTag } from "../ClientTag"

const PastClientsSectionFragment = graphql(`
  fragment PastClientsSection on IndividualCreative {
    id
    portfolioClients {
      edges {
        node {
          id
          avatarInitials
          name
          avatar80w: avatarUrl(width: 80)
        }
      }
    }
  }
`)

interface Props {
  creative: FragmentType<typeof PastClientsSectionFragment> | null | undefined
}

export const PastClientsSection: React.FC<Props> = props => {
  const creative = useFragment(PastClientsSectionFragment, props.creative)

  if (!creative?.portfolioClients?.edges?.length) {
    return null
  }
  return (
    <MetadataSectionContainer title="Past clients">
      <div className="flex flex-wrap gap-2">
        {creative?.portfolioClients?.edges?.map(edge => {
          const node = edge?.node
          return (
            <ClientTag
              key={node?.id}
              name={node?.name}
              avatarInitials={node?.avatarInitials}
              avatar80w={node?.avatar80w}
            />
          )
        })}
      </div>
      <div className="mt-5">
        <Separator />
      </div>
    </MetadataSectionContainer>
  )
}
